export const FETCH_TOKEN_ENDPOINT = 'v1/tokens';

export const REFRESH_TOKEN_ENDPOINT = `${FETCH_TOKEN_ENDPOINT}/refresh`;
